import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface Props {
  children: ReactNode;
  className?: string;
  strength?: number;
}

// Magnetic effect disabled — kept as a pass-through wrapper for API compatibility.
export function Magnetic({ children, className }: Props) {
  return <span className={cn("inline-block", className)}>{children}</span>;
}